// @ts-check
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PaginationLinks from './PaginationLinks';

class RoutedPaginationLinks extends Component {
  constructor() {
    super();
    this.pageParam = this.pageParam.bind(this);
    this.gotoPage = this.gotoPage.bind(this);
  }

  pageParam() {
    return this.props.pageParam || 'page_num';
  }

  gotoPage(pageNum) {
    const currentLocation = this.props.currentLocation;
    this.context.router.push({
      ...currentLocation,
      query: { ...currentLocation.query, [this.pageParam()]: pageNum },
    });
  }

  render() {
    const { id, totalPages, currentLocation } = this.props;

    const pageNum = parseInt(currentLocation.query[this.pageParam()] || 1);
    return (
      <PaginationLinks
        id={id}
        pageNum={pageNum}
        totalPages={totalPages}
        onPageClick={this.gotoPage}
      />
    );
  }
}

RoutedPaginationLinks.displayName = 'RoutedPaginationLinks';

RoutedPaginationLinks.propTypes = {
  currentLocation: PropTypes.object.isRequired,
  totalPages: PropTypes.number.isRequired,
  pageParam: PropTypes.string, // query string parameter name of the current page (e.g. pageNum)
  id: PropTypes.string, // id for DOM element
};

RoutedPaginationLinks.contextTypes = {
  router: PropTypes.object,
};

export default RoutedPaginationLinks;
